import * as React from "react";
import { useId } from "@utdanningsdirektoratet/utils/useId";
import { Tooltip } from "@utdanningsdirektoratet/tooltip";

type RadioGroupProps = {
  label?: string;
  className?: string;
  name?: string;
  children?: React.ReactNode;
  message?: React.ReactNode | string;
  error?: boolean;
};

const RadioGroup: React.FC<RadioGroupProps> = ({ label, name, children, className, error, message }) => {
  const id = useId();

  return (
    <Tooltip className={className} message={message} disabled={!error} alwaysShow={error} align="left" alert>
      <span id={id} role="group" aria-label={label}>
        {React.Children.map(children, (child) =>
          React.cloneElement(child as React.ReactElement, {
            name,
            "aria-labelledby": id,
            error,
          })
        )}
      </span>
    </Tooltip>
  );
};

export default RadioGroup;
